import * as constants from './constants';

export const getItemsCategories = (payload) => ({ type: constants.GET_ITEMS_CATEGORIES, payload });
export const resetItemsCategories = () => ({ type: constants.RESET_ITEMS_CATEGORIES });
export const getItemsCategoriesSuccess = (payload) => ({
  type: constants.GET_ITEMS_CATEGORIES_SUCCESS,
  payload,
});

export const getItemsCategoriesError = (payload) => ({
  type: constants.GET_ITEMS_CATEGORIES_ERROR,
  payload,
});
